import React from "react"
import { IoCloseOutline } from "react-icons/io5"

interface FeedBackModalProps {
  isOpen: boolean
  onClose: () => void
  onMessageSubmit?: (message: string) => void
  pendingMessage?: string
}

const FeedBackModal: React.FC<FeedBackModalProps> = ({
  isOpen,
  onClose,
  onMessageSubmit,
  pendingMessage = "",
}) => {
  const [message, setMessage] = React.useState(pendingMessage)

  React.useEffect(() => {
    setMessage(pendingMessage)
  }, [pendingMessage])

  if (!isOpen) return null

  const handleClose = () => {
    if (message.trim()) {
      onMessageSubmit?.(message.trim())
    }
    onClose()
  }

  // Mobile Bottom Sheet
  const mobileView = (
    <div
      className="sm:hidden fixed inset-0 z-[100] flex items-end justify-center bg-black/40"
      onClick={handleClose}
    >
      <div
        className="w-full bg-[#252525] rounded-t-[32px] flex flex-col animate-slideUp"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between p-6 pb-4">
          <h2 className="text-white text-2xl font-medium">
            Need help? Ping Us!
          </h2>
          <button
            onClick={handleClose}
            className="text-white/60 hover:text-white transition-colors bg-transparent"
          >
            <IoCloseOutline size={24} />
          </button>
        </div>
        <div className="px-6 pb-6">
          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Type your message..."
            className="w-full bg-transparent text-white placeholder-white/50 focus:outline-none text-lg resize-none"
            autoFocus
            style={{ height: "60vh" }}
          />
        </div>
      </div>
    </div>
  )

  // Desktop Modal
  const desktopView = (
    <div className="hidden sm:flex fixed inset-0 z-[100] items-center justify-center">
      <div className="fixed inset-0 bg-black/40" onClick={handleClose} />
      <div className="relative w-full max-w-2xl !bg-gray-500/10 rounded-2xl animate-fadeIn backdrop-blur-md border border-white/20">
        <div className="flex items-center justify-between p-8 border-b border-white/10">
          <h2 className="text-white text-2xl font-medium">
            Need help? Ping Us!
          </h2>
          <button
            onClick={handleClose}
            className="text-white/60 hover:text-white transition-colors bg-transparent"
          >
            <IoCloseOutline size={24} />
          </button>
        </div>
        <div className="p-8">
          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Type your message..."
            className="w-full min-h-[300px] bg-transparent text-white placeholder-white/50 focus:outline-none text-lg resize-none"
            autoFocus
          />
        </div>
      </div>
    </div>
  )

  return (
    <>
      {mobileView}
      {desktopView}
      <style>{`
        @keyframes slideUp {
          from { transform: translateY(100%); }
          to { transform: translateY(0); }
        }
        .animate-slideUp {
          animation: slideUp 0.3s ease-out forwards;
        }
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: scale(0.95);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }
        .animate-fadeIn {
          animation: fadeIn 0.2s ease-out forwards;
        }
      `}</style>
    </>
  )
}

export default FeedBackModal
